import * as XLSX from 'xlsx';
import { construirReporteExportacion } from '../pages/Recepcion/reportes/exportacionReporte';

// Exportación a Excel de los reportes de Recepción. 100% client-side (igual que el PDF de
// ReportesPDF.js): una hoja por reporte, armadas desde construirReporteRecepcion — la misma
// estructura que usa el PDF, así los dos documentos traen siempre los mismos reportes con los
// mismos números y ninguno se queda atrás cuando se agrega un gráfico a la pantalla.

// Excel no acepta nombres de hoja de más de 31 caracteres ni con []:*?/\ y exige que sean únicos.
function nombreDeHoja(wb, nombre) {
    const base = String(nombre).replace(/[[\]:*?/\\]/g, ' ').slice(0, 31).trim() || 'Hoja';
    let candidato = base;
    let sufijo = 2;
    while (wb.SheetNames.includes(candidato)) {
        const extra = ` (${sufijo})`;
        candidato = base.slice(0, 31 - extra.length) + extra;
        sufijo += 1;
    }
    return candidato;
}

function agregarHoja(wb, nombre, columnas, filas) {
    const cuerpo = filas.map((fila) => fila.map((valor) => (valor === null || valor === undefined ? '' : valor)));
    const hoja = XLSX.utils.aoa_to_sheet([columnas, ...cuerpo]);
    // Ancho de columna según el contenido más largo, con tope para que las de texto libre no
    // queden kilométricas.
    hoja['!cols'] = columnas.map((columna, i) => ({
        wch: Math.min(60, Math.max(String(columna).length, ...cuerpo.map((fila) => String(fila[i] ?? '').length)) + 2),
    }));
    XLSX.utils.book_append_sheet(wb, hoja, nombreDeHoja(wb, nombre));
}

export const generarExcelReporte = (config) => {
    const reporte = construirReporteExportacion(config);
    const wb = XLSX.utils.book_new();

    agregarHoja(wb, 'Filtros', ['Filtro', 'Valor'], reporte.filtros);
    if (reporte.kpis.length > 0) agregarHoja(wb, 'Resumen', ['Indicador', 'Valor'], reporte.kpis);
    if (reporte.alertas.length > 0) agregarHoja(wb, 'Alertas', ['Alerta', 'Detalle'], reporte.alertas.map((a) => [a.titulo, a.texto]));

    reporte.pestanas.forEach((pestana) => {
        pestana.secciones.forEach((seccion) => {
            agregarHoja(wb, seccion.hoja, seccion.columnas, seccion.filas);
        });
    });

    return wb;
};

export const descargarExcel = (wb, nombreArchivo) => {
    XLSX.writeFile(wb, `${nombreArchivo}_${new Date().toISOString().split('T')[0]}.xlsx`);
};

export const useExcelReportes = () => {
    const generarYDescargar = (config, nombreArchivo = 'reporte_recepcion') => {
        const wb = generarExcelReporte(config);
        descargarExcel(wb, nombreArchivo);
    };
    return { generarYDescargar };
};

const ReportesExcelUtils = { generarExcelReporte, descargarExcel, useExcelReportes };
export default ReportesExcelUtils;
